
import { Component, Mixins } from "vue-property-decorator";
import { ICopyLinkedValuesBehavior } from "../../../../../../documaker/domain/format/objects";
import { ICopyLinkedTextsBehaviorPropertyEditable, instanceOfICopyLinkedTextsBehaviorPropertyEditable } from "../../../../../domain/editableFormat/properties"; 

@Component
export default class CopyLinkedTextsBehaviorPropertyEditableMixin extends Mixins() {
  writePropertyWhenValid: (writer: (source: ICopyLinkedTextsBehaviorPropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: ICopyLinkedTextsBehaviorPropertyEditable) => T, defaultValue: T) => T;

  get isCopyLinkedTextsBehaviorPropertyEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfICopyLinkedTextsBehaviorPropertyEditable(s) && s.copyLinkedTextsBehavior().isEditable(), false);
  }

  get copyLinkedTextsBehavior(): ICopyLinkedValuesBehavior {
    return this.readPropertyOrDefault(s => s.copyLinkedTextsBehavior().getValue(), { links: null, isEnable: false });
  }

  set copyLinkedTextsBehavior(value: ICopyLinkedValuesBehavior) {
    this.writePropertyWhenValid(s => s.copyLinkedTextsBehavior().setValue(value));
  }
}
